module.exports = __webpack_public_path__ + "img/zaoyinpaichuRight.a7643544.png";